export const color= {
    primary: "#D1A074",
    secondary: "#6c757d",
    success: "#0c673b",
    danger: "#dc3545",
    warning: "#ffc107",
    info: "#17a2b8",
    light: "#f8f9fa",
    dark: "#343a40"
}
